import { createSlice } from "@reduxjs/toolkit";

const supplierOfficeSlice = createSlice({
  name: "supplierOffice",
  initialState: {
    supplierOffice: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    supplierStart: (state) => {
      state.isFetching = true;
    },
    supplierSuccess: (state, action) => {
      state.supplierOffice = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    supplierFailure: (state, action) => {
      state.supplierOffice = action.payload;
      state.isFetching = false;
      state.error = true;
    },
    supplierOfficeStart: (state) => {
      state.isFetching = true;
    },
    supplierOfficeSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
    },
    supplierOfficeFailure: (state) => {
      state.currentSupplier = null;
      state.isFetching = false;
      state.error = true;
    },
    editSupplierOfficeSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
    },
    logoutInfoSupplier: (state) => {
      state.supplierOffice = null;
      state.currentSupplier = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  supplierStart,
  supplierOfficeStart,
  supplierOfficeFailure,
  supplierOfficeSuccess,
  supplierFailure,
  supplierSuccess,
  editSupplierOfficeSuccess,
  logoutInfoSupplier,
} = supplierOfficeSlice.actions;

export default supplierOfficeSlice.reducer;
